import { createAtom, Store as StoreType } from '@basaldev/js-atom';
import atomDevTools from '@basaldev/js-atom-devtools';

import { createInitialState } from '@campaign/domain/store/state';
import { State } from '@campaign/types';

export type Store = StoreType<State>;

export const store = createAtom<State>(createInitialState());

store.addWatch('atom-devtools', atomDevTools);

export function getState(): State {
  return store.deref();
}
